import { OEM_HISTORY_REQUEST, OEM_HISTORY_SUCCESS, OEM_HISTORY_FAIL } from '../type/type';


const initialState = {
    oemHistory: [],
    historyLoading: false,
    histroyError: null,
};

const oemHistoryReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case OEM_HISTORY_REQUEST:
            return { ...state, historyLoading: true, histroyError: null };
        case OEM_HISTORY_SUCCESS:
            return { ...state, historyLoading: false, oemHistory: payload };
        case OEM_HISTORY_FAIL:
            return { ...state, historyLoading: false, histroyError: payload };
        default:
            return state;
    }
};

export default oemHistoryReducer;  
